import { render, staticRenderFns } from "./TechnicalRevision.vue?vue&type=template&id=7f99fe8a"
import script from "./TechnicalRevision.vue?vue&type=script&lang=js"
export * from "./TechnicalRevision.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports